import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/about-us.js'), 'about-us.js')
  resolveStoreModules(require('../store/approved-license.js'), 'approved-license.js')
  resolveStoreModules(require('../store/article-categories.js'), 'article-categories.js')
  resolveStoreModules(require('../store/articles.js'), 'articles.js')
  resolveStoreModules(require('../store/auth.js'), 'auth.js')
  resolveStoreModules(require('../store/careers.js'), 'careers.js')
  resolveStoreModules(require('../store/contact-information.js'), 'contact-information.js')
  resolveStoreModules(require('../store/dashboard.js'), 'dashboard.js')
  resolveStoreModules(require('../store/faq.js'), 'faq.js')
  resolveStoreModules(require('../store/internal-portal-setting.js'), 'internal-portal-setting.js')
  resolveStoreModules(require('../store/jobs.js'), 'jobs.js')
  resolveStoreModules(require('../store/language-strings.js'), 'language-strings.js')
  resolveStoreModules(require('../store/menubars.js'), 'menubars.js')
  resolveStoreModules(require('../store/missions.js'), 'missions.js')
  resolveStoreModules(require('../store/news.js'), 'news.js')
  resolveStoreModules(require('../store/organization-chart.js'), 'organization-chart.js')
  resolveStoreModules(require('../store/permissions.js'), 'permissions.js')
  resolveStoreModules(require('../store/policies.js'), 'policies.js')
  resolveStoreModules(require('../store/project-bidding.js'), 'project-bidding.js')
  resolveStoreModules(require('../store/projects.js'), 'projects.js')
  resolveStoreModules(require('../store/regulations.js'), 'regulations.js')
  resolveStoreModules(require('../store/settings.js'), 'settings.js')
  resolveStoreModules(require('../store/sliders.js'), 'sliders.js')
  resolveStoreModules(require('../store/sub-menubars.js'), 'sub-menubars.js')
  resolveStoreModules(require('../store/users.js'), 'users.js')
  resolveStoreModules(require('../store/vision.js'), 'vision.js')
  resolveStoreModules(require('../store/internal/application-tracking.js'), 'internal/application-tracking.js')
  resolveStoreModules(require('../store/internal/devices.js'), 'internal/devices.js')
  resolveStoreModules(require('../store/internal/employee-management.js'), 'internal/employee-management.js')
  resolveStoreModules(require('../store/internal/ip.js'), 'internal/ip.js')
  resolveStoreModules(require('../store/internal/lcm.js'), 'internal/lcm.js')
  resolveStoreModules(require('../store/internal/master.js'), 'internal/master.js')
  resolveStoreModules(require('../store/internal/operator.js'), 'internal/operator.js')
  resolveStoreModules(require('../store/internal/permissions.js'), 'internal/permissions.js')
  resolveStoreModules(require('../store/internal/reports.js'), 'internal/reports.js')
  resolveStoreModules(require('../store/internal/role-permissions.js'), 'internal/role-permissions.js')
  resolveStoreModules(require('../store/internal/user-activity.js'), 'internal/user-activity.js')
  resolveStoreModules(require('../store/internal/users.js'), 'internal/users.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
